// components/Video.js
import React from "react";

const Video = ({ src, poster, caption, preload = "metadata", className }) => {
	return (
		<figure className={className ?? "my-8 lg:my-12"}>
			<video
				className="w-full rounded-2xl ring-1 ring-black/10"
				controls
				preload={preload}
				poster={poster}
			>
				<source src={src} />
				Your browser does not support the video tag.
			</video>
			{caption ? (
				<figcaption className="text-xs lg:text-sm italic text-center mt-[-16px] lg:mt-[-32px] mb-6 lg:mb-8">
					{caption}
				</figcaption>
			) : null}
		</figure>
	);
};

export default Video;
